import React from "react";
import { components } from "react-select";
import { Spinner } from "reactstrap";
import { useCalendarContext } from "../../../lib/context/Calendar/CalendarContext";

export const DirectoryMenuList = (props: any) => {
  const { searching, handleDirectorySearch, showNarrowOption } = props;
  const inputValue = props.selectProps.inputValue;
  const { personalCalendar } = useCalendarContext();

  return (
    <components.MenuList {...props}>
      {searching && (
        <div className="SearchingDirectory pt-min">
          <Spinner size="sm" color="primary" className="mr-2" />
          {searching}
        </div>
      )}
      {showNarrowOption ? (
        <div className="SearchingDirectory SearchingDirectory__narrow">
          Type more to narrow you search...
        </div>
      ) : (
        props.children
      )}

      {!!personalCalendar?.length &&
        !!personalCalendar[0].iD &&
        props.selectProps.inputValue?.length > 1 && (
          <div
            className="SearchDirectory"
            style={{
              cursor: searching ? "not-allowed" : "pointer",
              opacity: searching ? 0.5 : 1,
            }}
            onMouseDown={(e) => {
              if (searching) return;
              e.preventDefault();
              handleDirectorySearch(inputValue || "");
            }}
          >
            <span>Search directory</span>
          </div>
        )}
    </components.MenuList>
  );
};
